<template>
  <section class="mid_scroll_content transition-history-page"> 
    <alert-notification v-if="notification_msg != ''" /> 
    <loader v-if="pageLoader" />
    <div class="row mt-4 mx-0">
      <div class="col-12">
        <div
          class="mainTitle mb-4 d-flex align-items-center justify-content-between"
        >
          <div class="titleBlock mb-4">
            <h3>Recent Orders</h3>
            <p>Good {{ dayTime }}<span v-if="get_user.profile.firstname">{{ get_user.profile.firstname }}</span>! These are your recent orders</p>
          </div>
          <!-- <change-account></change-account> -->
        </div>
        <div class="cryptoQuantity d-flex align-items-center my-4">
          <div class="card-body mr-4" v-for="(item, index) in orderList.records" :index="index" v-show="index < 4">
            <div class="col">
              <span class="f-14 status" :class="item.OrderType == 'M'? 'yellowBG' : item.OrderSide ? 'greenBG' : 'redBG'">{{ orderType[item.OrderType] }}
                {{item.OrderType != "M" ? orderSide[item.OrderSide] : ""}}</span>
              <div class="valueExchange my-3">
                <p class="mb-1">Quantity</p>
                <!-- <h5 v-if="item.QuantityFilled">
									{{item.QuantityFilled}}
									<span>{{item.Symbol.split('-')[1]}}</span>
								</h5> -->
                <h5 v-if="item.QuantityFilled && item.OrderSide == 0">
                  {{floatingValue(item.QuantityFilled * item.PriceFilled - item.Commission,spliting(item.Symbol, 1))}}
                  <!-- {{ spliting(item.Symbol, 1) }} -->
                  <span v-if="item.Symbol != undefined && item.Symbol != null && item.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(item.Symbol, 1))">{{ $env_var.restricted_currencies[spliting(item.Symbol, 1)].currency_name }}</span>
                  <span v-else>{{ spliting(item.Symbol, 1) || "-" }}</span>
                </h5>
                <h5 v-else-if="item.QuantityFilled && item.OrderSide == 1">
                  {{floatingValue(item.QuantityFilled, spliting(item.Symbol, 0)) }}
                  <!-- {{ spliting(item.Symbol, 0) }} -->
                  <span v-if="item.Symbol != undefined && item.Symbol != null && item.Symbol != '' &&  $env_var.restricted_currencies.hasOwnProperty(spliting(item.Symbol, 0))">{{ $env_var.restricted_currencies[spliting(item.Symbol, 0)].currency_name }}</span>
                  <span v-else>{{ spliting(item.Symbol, 0) || "-" }}</span>
                </h5>
                <h5 v-else-if="!item.QuantityFilled">
                  {{ item.Quantity }}
                  <span v-if="item.OrderSide == 0">
                  <!-- {{spliting(item.Symbol, 1)}} -->
                    <span v-if="item.Symbol != undefined && item.Symbol != null && item.Symbol != '' &&  $env_var.restricted_currencies.hasOwnProperty(spliting(item.Symbol, 1))">{{ $env_var.restricted_currencies[spliting(item.Symbol, 1)].currency_name }}</span>
                    <span v-else>{{ spliting(item.Symbol, 1) || "-" }}</span>
                  </span>
                  <span v-if="item.OrderSide == 1">
                  <!-- {{spliting(item.Symbol, 0)}} -->
                    <span v-if="item.Symbol != undefined && item.Symbol != null && item.Symbol != '' &&  $env_var.restricted_currencies.hasOwnProperty(spliting(item.Symbol, 0))">{{ $env_var.restricted_currencies[spliting(item.Symbol, 0)].currency_name }}</span>
                    <span v-else>{{ spliting(item.Symbol, 0) || "-" }}</span>
                  </span>
                </h5>
              </div>
              <div class="pt-2 d-flex align-items-center justify-content-between border-top">
                <span class="medium green f-12">Order ID
                  <span class="d-block dir themecolor">{{item.OrderId}}</span></span>
                <span class="medium f-12">
                  Placed on
                  <span class="d-block dir" v-if="item.sortDate">{{item.sortDate.split("T")[0] | moment("do MMM YYYY")}}</span>
                  <span class="d-block dir" v-else>{{item.sortDate.split("T")[0] | moment("do MMM YYYY") }}</span>
                </span>
                <span class="medium f-12">Status
                  <span class="d-block dir yellow" :class="statusTypeList[item.Status].class">
                    {{ statusTypeList[item.Status].text }}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <h3 class="medium my-4">Transaction History</h3>
        <div class="d-flex align-items-center justify-content-between flex-wrap tHis my-5">
          <ul class="d-flex align-items-center priceTab mb-lg-0">
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" @click.prevent="type = '2';page = '1'; " :class="type == '2' ? 'active' : ''">
                Completed
                <span class="status borderBG">{{ orderList.totalRecords.filled || 0 }}</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" :class="type == '1' ? 'active' : 'deposit_bg'" @click.prevent="type = '1';page = '1';">
                Open
                <span class="status borderBG">{{orderList.totalRecords.open || 0}}</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" :class="type == '3' ? 'active' : 'deposit_bg'" @click.prevent="type = '3';page = '1';">
                Rejected
                <span class="status borderBG">{{orderList.totalRecords.cancel || 0}}</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" :class="[type == '4' ? 'active' : 'deposit_bg',{ disabled: pageLoader },]" @click.prevent="type = '4';page = '1';depositListing(); dateType= '' ; downloadData = {}">
                Deposits
                <span class="status borderBG">{{depsitList.totalRecords || 0}}</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" :class="[type == '5' ? 'active' : 'deposit_bg',{ disabled: pageLoader },]" @click.prevent="type = '5';page = '1';withdrawalListing(); ; dateType= '' ; downloadData = {}">
                Withdrawals
                <span class="status borderBG">{{withdrawalList.totalRecords || 0}}</span>
              </a>
            </li>
          </ul>
          <div  class="d-flex align-items-center mr-3"  v-if="type != 4 && type != 5">
            <label class="toggleSwitch">
              <input type="checkbox" v-model="basicAdv" />
              <span class="slider round"></span>
            </label>
            <p class="mb-0 ml-3">Basic Mode</p>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="dataTable-transition">
          <div class="border position-relative border-radius-15" v-show="type == '1'">
            <div class="d-flex align-items-center justify-content-end p-3 border-bottom">
              <a href="javascript:void(0)"  @click="() => downloadTransactions()" class="borderBtn mr-3" >Download Transactions</a>
              <div class="form-group position-relative includeIco searchTable mb-0">
                <input type="text" placeholder="Search by Orders Number"  name="legal_name"  class="form-control small" v-model="searchOrderNumber"/>
                <span class="searchIco"><feather type="search"></feather></span>
              </div>
            </div>
            <div class="tableStructure tableCustomScroll-filter">
              <div class="customPop-up" v-show="Object.keys(deleteOrderVal).length > 0">
                <div class="popupBody">
                  <div class="imgSrc-pop">
                    <img  src="../../../../static/website/images/ipAdd.svg"  alt="Icon"  />
                  </div>
                  <p>Are you sure you want to Cancel this Order?</p>
                  <div class="popfooter">
                    <button class="cap_btn-b blue" @click="close()">
                      Cancel
                    </button>
                    <button class="cap_btn blue" @click="cancelOrder()">
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
              <div class="marketData table-responsive innerScrollbar">
                <table class="table table-striped table-bordered" width="100%">
                  <thead class="thead-white">
                    <tr v-if="basicAdv">
                      <th width="150px" scope="col">Date</th>
                      <th width="150px" scope="col">Market</th>
                      <th width="150px" scope="col">Side</th>
                      <th width="150px" scope="col">Type</th>
                      <!-- <th width="150px" scope="col">Price</th> -->
                      <th width="150px" scope="col">Quantity</th>
                      <th width="150px" scope="col">TX ID</th>
                      <th width="150px" scope="col">Status</th>
                      <th v-if="type == '1'">Close Order</th>
                    </tr>
                    <tr v-if="!basicAdv">
                      <th width="150px" scope="col">Date</th>
                      <th width="150px" scope="col">Market</th>
                      <th width="150px" scope="col">Total fees</th>
                      <th width="150px" scope="col">Ex Rate</th>
                      <th width="150px" scope="col">TX ID</th>
                      <th width="150px" scope="col">AMT Received</th>
                      <th width="150px" scope="col">Commentary</th>
                      <th width="150px" scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody v-if="filteredOrders.length > 0">
                    <tr v-for="(val, index) in filteredOrders"  v-if="index >= (page - 1) * pageLimit && index < page * pageLimit &&  basicAdv">
                      <td>{{ formatDate(val.Opened || val.sortDate) }}</td>
                      <td>
                        <!-- {{ val.Symbol }} -->
                        <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' &&  $env_var.restricted_currencies.hasOwnProperty(val.Symbol)">{{ $env_var.restricted_currencies[val.Symbol].currency_name }}</span>
                        <span v-else>{{ val.Symbol || "-" }}</span>
                      </td>
                      <td class="red">
                        {{val.OrderSide == 0 ? "SELL"  : val.OrderSide == 1 ? "BUY"  : "-"}}
                      </td>
                      <td>{{ orderType[val.OrderType] }}</td>
                      <td>{{ val.Quantity }}</td>
                      <td>
                        <span class="status yellowBG">{{ val.OrderId }}</span>
                      </td>
                      <td><span class="open">OPEN</span></td>
                      <td @click="open(val)">
                        <feather type="x-circle"></feather>
                      </td>
                    </tr>
                    <tr v-for="(val, index) in filteredOrders"  v-if=" index >= (page - 1) * pageLimit &&  index < page * pageLimit &&  !basicAdv ">
                      <td>{{ formatDate(val.Opened || val.sortDate) }}</td>
                      <td v-if="type == '2'">
                        {{ formatDate(val.Closed || val.sortDate) }}
                      </td>
                      <td v-if="type == '3'">
                        {{ formatDate(val.Canceled || val.sortDate) }}
                      </td>
                      <!-- <td
                        v-html="
                          val.OrderSide == 0
                            ? val.Quantity + ' ' + spliting(val.Symbol, 0)
                            : val.Quantity + ' ' + spliting(val.Symbol, 0)
                        "
                      > -->
                      <td v-if="val.OrderSide == 0">
                        <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(val.Symbol, 0))">{{ val.Quantity + ' ' + $env_var.restricted_currencies[spliting(val.Symbol, 0)].currency_name }}</span>
                        <span v-else>{{ val.Quantity + ' ' + spliting(val.Symbol, 0) }}</span>
                      </td>
                      <td v-if="val.OrderSide == 1">
                        <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(val.Symbol, 0))">{{ val.Quantity + ' ' + $env_var.restricted_currencies[spliting(val.Symbol, 0)].currency_name }}</span>
                        <span v-else>{{ val.Quantity + ' ' + spliting(val.Symbol, 0) }}</span>
                      </td>
                        
                     
                      <td v-html=" 'Commission' in val  ? formatfloat(val.Commission)  : '-' "></td>
                      <td v-html="val.Price || val.StopPrice || '-'"></td>
                      <td>  <span class="status yellowBG">{{ val.OrderId }}</span> </td>
                      <td v-html="  val.Price || val.StopPrice  ? (val.Price || val.StopPrice) * val.Quantity : '-' "></td>
                      <td><span class="open">OPEN</span></td>
                      <td>{{val.Commentary || '-'}}</td>
                      <td @click="open(val)">
                        <feather type="x-circle"></feather>
                      </td>
                    </tr>
                  </tbody>
                  <table-loader  :pageloader_value="pageLoader" :type="'table'" :colspan="'8'" :listLength="orderData('1').length" v-else></table-loader>
                </table>
              </div>
            </div>
            <pagination :totalRecords="orderData('1').length" :limit="pageLimit" :pageNo="page" v-if="orderData('1').length > 0 && !pageLoader && type == '1'"
            ></pagination>
          </div>
          <div  class="border position-relative border-radius-15"  v-show="type == '2'" >
            <div class="row justify-content-center">
              <div class="col-12">
                <!-- <div
                  class="d-flex align-items-center justify-content-between filterWrap border-bottom p-3"
                > -->
                <div
                  class="d-flex align-items-center justify-content-between border-bottom p-3"
                >
                  <div class="d-flex align-items-center">
                    <div
                      class="form-group position-relative includeIco searchTable mb-0"
                    >
                      <input
                        type="text"
                        placeholder="Search by Orders Number"
                        name="legal_name"
                        class="form-control small"
                        v-model="searchOrderNumber"
                      />
                      <span class="searchIco"
                        ><feather type="search"></feather>
                      </span>
                    </div>
                  </div>
                  <div
                    class="filterCustom d-flex justify-content-end transactionId"
                  >
                    <a
                      href="javascript:void(0)"
                     
                      @click="() => downloadTransactions()"
                      class="borderBtn mr-3"
                      >Download Transactions</a
                    >
                    <div class="form-group mr-2 mb-0">
                      <select
                        name="Date"
                        class="form-control"
                        v-model="dateType"
                        v-validate="'required'"
                        @change="changeFilter()"
                      >
                        <option value="">Select Days</option>
                        <option value="7 Days">Last 7 Days</option>
                        <option value="15 Days">Last 15 Days</option>
                        <option value="30 Days">Last 30 Days</option>
                        <option value="3 Months">Last 3 Months</option>
                        <option value="6 Months">Last 6 Months</option>
                        <!-- <option value="custom">Custom</option> -->
                      </select>
                      <span
                        v-show="submitted && errors.has('Date')"
                        class="text-danger"
                        >Days are required</span
                      >
                    </div>
                    <div
                      class="showReflect d-flex mx-2"
                      v-if="dateType == 'custom'"
                    >
                      <div class="form-group calcLeft mr-2">
                        <datepicker
                          class="form-control datepicker"
                          placeholder="from Date"
                          name="fromDate"
                          v-model="fromDate"
                          v-validate="'required'"
                          :lang="'en'"
                          :typeable="true"
                          :format="'DD-MM-YYYY'"
                        >
                        </datepicker>
                        <span
                          v-show="submitted && errors.has('fromDate')"
                          class="text-danger"
                          >From Date is required</span
                        >
                      </div>
                      <div class="form-group calcRight">
                        <datepicker
                          class="form-control datepicker"
                          placeholder="To Date"
                          name="toDate"
                          v-model="toDate"
                          v-validate="'required'"
                          :lang="'en'"
                          :typeable="true"
                          :format="'DD-MM-YYYY'"
                        >
                        </datepicker>
                        <span
                          v-show="submitted && errors.has('toDate')"
                          class="text-danger"
                          >To Date is required</span
                        >
                      </div>
                    </div>
                    <!-- <a class="cap_btn blue" href="#" @click.prevent="findDate()"
                      >Submit</a
                    > -->
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered table-responsive" width="100%">
                <thead class="thead-white">
                  <tr v-if="basicAdv">
                    <th width="150px" scope="col">Date</th>
                    <th width="150px" scope="col">Order Number</th>
                    <th width="150px" scope="col">Market</th>
                    <th width="150px" scope="col">Side</th>
                    <th width="150px" scope="col">Quantity</th>
                    <th width="150px" scope="col">Price</th>
                    <th width="150px" scope="col">Total fees</th>
                    <th width="150px" scope="col">Balance</th>
                  </tr>
                  <tr v-if="!basicAdv">
                    <th width="150px" scope="col">Date</th>
                    <th width="50px" scope="col">Order type</th>
                    <th width="50px" scope="col">Order Number</th>
                    <th width="150px" scope="col">Quantity received</th>
                    <!-- <th width="150px" scope="col">Price</th> -->
                    <th width="150px" scope="col">Conversion Detail</th>
                    <th width="150px" scope="col">Commentary</th>
                    <!-- <th width="150px" scope="col">Total fees</th>
										<th width="150px" scope="col">Ex Rate</th>
										<th width="150px" scope="col">TX ID</th>
										<th width="150px" scope="col">AMT RECEIVED</th>
										<th width="150px" scope="col">% Filled</th>
										<th width="150px" scope="col">Status</th> -->
                  </tr>
                </thead>
                <tbody v-if="filteredOrders.length > 0">
                  <tr
                    v-for="(val, index) in filteredOrders"
                    v-if="
                      index >= (page - 1) * pageLimit &&
                      index < page * pageLimit &&
                      basicAdv
                    "
                  >
                    <td>{{ formatDate(val.Closed || val.sortDate) }}</td>
                    <!-- <td>{{(val.OrderSide == 0) ? spliting(val.Symbol,1) :(val.OrderSide == 1)}}</td> -->
                    <td>
                      <span class="status yellowBG">{{ val.OrderId }}</span>
                    </td>
                    <td>
                      {{ val.Symbol }}
                      <!-- <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(val.Symbol.split('-')[0])">{{ $env_var.restricted_currencies[val.Symbol.split('-')[0]].currency_name }}</span>
                      <span v-else>{{ val.Symbol.split('-')[0] || "-" }}</span>
                      to
                      <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(val.Symbol.split('-')[1])">{{ $env_var.restricted_currencies[val.Symbol.split('-')[1]].currency_name }}</span>
                      <span v-else>{{ val.Symbol.split('-')[1] || "-" }}</span> -->
                      <!-- <span v-else>{{ val.Symbol || "-" }}</span> -->
                    </td>
                    <td
                      :class="
                        val.OrderSide == 0
                          ? 'red'
                          : val.OrderSide == 1
                          ? 'green'
                          : ''
                      "
                    >
                      {{
                        val.OrderSide == 0
                          ? "SELL"
                          : val.OrderSide == 1
                          ? "BUY"
                          : "-"
                      }}
                    </td>
                    <td>{{ formatfloat(val.QuantityFilled) }}</td>
                    <!-- <td>{{orderType[val.OrderType]}}</td> -->
                    <td>{{ formatfloat(val.PriceFilled) }}</td>
                    <td>
                      {{ formatfloat(val.Commission) }}
                      <!-- {{ spliting(val.Symbol, 1) }} -->
                      <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(val.Symbol, 1))">{{ $env_var.restricted_currencies[spliting(val.Symbol, 1)].currency_name }}</span>
                      <span v-else>{{ spliting(val.Symbol, 1) || "-" }}</span>
                    </td>
                    <td v-if="val.OrderSide == 0">
                      {{
                        formatfloat(
                          val.QuantityFilled * val.PriceFilled - val.Commission
                        )
                      }}
                    </td>
                    <td v-if="val.OrderSide == 1">
                      {{ formatfloat(val.QuantityFilled) }}
                    </td>
                    <!-- <td><span class="alert alert-success" v-html="val.QuantityFilled == val.Quantity? 'Completed': 'Partially Filled'"></span></td> -->
                  </tr>
                  <tr
                    v-for="(val, index) in filteredOrders"
                    v-if="
                      index >= (page - 1) * pageLimit &&
                      index < page * pageLimit &&
                      !basicAdv
                    "
                  >
                    <td>{{ formatDate(val.Closed || val.sortDate) }}</td>
                    <td>
                      <span
                        class="status"
                        :class="
                          val.OrderType == 'M'
                            ? 'yellowBG'
                            : val.OrderSide
                            ? 'greenBG'
                            : 'redBG'
                        "
                        >{{ orderType[val.OrderType] }}
                        {{
                          val.OrderType != "M" ? orderSide[val.OrderSide] : ""
                        }}</span
                      >
                    </td>
                    <td>{{ val.OrderId }}</td>
                    <td v-if="val.OrderSide == 0">
                      {{
                        floatingValue(
                          val.QuantityFilled * val.PriceFilled - val.Commission,
                          spliting(val.Symbol, 1)
                        )
                      }}
                      <!-- {{ spliting(val.Symbol, 1) }} -->
                      <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(val.Symbol, 1))">{{ $env_var.restricted_currencies[spliting(val.Symbol, 1)].currency_name }}</span>
                      <span v-else>{{ spliting(val.Symbol, 1) || "-" }}</span>
                    </td>
                    <td v-if="val.OrderSide == 1">
                      {{
                        floatingValue(
                          val.QuantityFilled,
                          spliting(val.Symbol, 0)
                        )
                      }}
                      <!-- {{ spliting(val.Symbol, 0) }} -->
                      <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(val.Symbol, 0))">{{ $env_var.restricted_currencies[spliting(val.Symbol, 0)].currency_name }}</span>
                      <span v-else>{{ spliting(val.Symbol, 0) || "-" }}</span>
                    </td>
                    <!-- <td> {{(val.OrderSide == 0) ? formatfloat(1/val.PriceFilled) : formatfloat(val.PriceFilled)}} {{(val.OrderSide == 0) ? spliting(val.Symbol,0) : spliting(val.Symbol,1)}}</td> -->
                    <!-- <td>{{formatfloat(val.PriceFilled)}}</td> -->
                    <td v-if="val.OrderSide == 0">
                      Sold
                      {{
                        floatingValue(
                          val.QuantityFilled,
                          spliting(val.Symbol, 0)
                        )
                      }}
                      <!-- {{ spliting(val.Symbol, 0) }} -->
                      <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(val.Symbol, 0))">{{ $env_var.restricted_currencies[spliting(val.Symbol, 0)].currency_name }}</span>
                      <span v-else>{{ spliting(val.Symbol, 0) || "-" }}</span>
                       for
                      {{
                        floatingValue(
                          val.QuantityFilled * val.PriceFilled - val.Commission,
                          spliting(val.Symbol, 1)
                        )
                      }}
                      <!-- {{ spliting(val.Symbol, 1) }} -->
                      <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(val.Symbol, 1))">{{ $env_var.restricted_currencies[spliting(val.Symbol, 1)].currency_name }}</span>
                      <span v-else>{{ spliting(val.Symbol, 1) || "-" }}</span>
                    </td>
                    <td v-if="val.OrderSide == 1">
                      Bought
                      {{
                        floatingValue(
                          val.QuantityFilled,
                          spliting(val.Symbol, 0)
                        )
                      }}
                      <!-- {{ spliting(val.Symbol, 0) }}  -->
                      <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(val.Symbol, 0))">{{ $env_var.restricted_currencies[spliting(val.Symbol, 0)].currency_name }}</span>
                      <span v-else>{{ spliting(val.Symbol, 0) || "-" }}</span>
                      for
                      {{
                        floatingValue(
                          val.QuantityFilled * val.PriceFilled,
                          spliting(val.Symbol, 1)
                        )
                      }}
                      <!-- {{ spliting(val.Symbol, 1) }} -->
                      <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(spliting(val.Symbol, 1))">{{ $env_var.restricted_currencies[spliting(val.Symbol, 1)].currency_name }}</span>
                      <span v-else>{{ spliting(val.Symbol, 1) || "-" }}</span>
                    </td>
                    <td>{{val.Commentary || '-'}}</td>
                    <!-- <td v-html='(val.OrderSide == 0)? formatfloat(val.Quantity)+ spliting(val.Symbol,1):val.Quantity+" "+  spliting(val.Symbol,0)'></td>
										<td v-html='"Commission" in val ? formatfloat(val.Commission) : "-"'></td>
										<td v-html='val.PriceFilled ? formatfloat(val.PriceFilled) : "-"'></td>
										<td>{{val.OrderId}}</td>
										<td v-html='val.PriceFilled ? val.PriceFilled*val.QuantityFilled : "-"'></td>
										<td v-html='((val.QuantityFilled/val.Quantity)*100).toFixed(4)'></td>
										<td v-html="val.QuantityFilled == val.Quantity? 'Filled': 'Pending'"></td> -->
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'8'"
                  :listLength="orderData('2').length"
                  v-else
                ></table-loader>
              </table>
            </div>
            <pagination
              :totalRecords="orderData('2').length"
              :limit="pageLimit"
              :pageNo="page"
              v-if="orderData('2').length > 0 && !pageLoader && type == '2'"
            ></pagination>
          </div>
          <div  class="border position-relative border-radius-15"  v-show="type == '3'">
            <div
              class="d-flex align-items-center justify-content-end border-bottom p-3"
            >
              <a
                href="javascript:void(0)"
              
                @click="() => downloadTransactions()"
                class="borderBtn mr-3"
                >Download Transactions</a
              >
              <div
                class="form-group position-relative includeIco searchTable mb-0"
              >
                <input
                  type="text"
                  placeholder="Search by Orders Number"
                  name="legal_name"
                  class="form-control small"
                  v-model="searchOrderNumber"
                />
                <span class="searchIco"
                  ><feather type="search"></feather>
                </span>
              </div>
            </div>
            <div class="tableStructure tableheightScroll">
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-responsive" width="100%">
                  <thead class="thead-white">
                    <tr>
                      <!-- <th width="150px" scope="col">Closed Date </th> -->
                      <th width="150px" scope="col">Closed Date</th>
                      <th width="150px" scope="col">Order ID</th>
                      <th width="150px" scope="col">Market</th>
                      <th width="150px" scope="col">Side</th>
                      <th width="150px" scope="col">Order Type</th>
                      <!-- <th width="150px" scope="col">TX ID</th> -->
                      <th width="150px" scope="col">Pair</th>
                      <!--  <th width="150px" scope="col">Price</th> -->
                      <th width="150px" scope="col">Quantity</th>
                      <!-- <th width="150px" scope="col">Est. USD Val</th>
                      <th width="150px" scope="col">Filled Rate</th>
                      <th width="150px" scope="col">Total</th> -->
                      <th width="150px" scope="col">Reason</th>
                      <th width="150px" scope="col">Status</th>
                      <th width="150px" scope="col">Commentary</th>
                    </tr>
                  </thead>
                  <tbody v-if="filteredOrders.length > 0">
                    <tr
                      v-for="(val, index) in filteredOrders"
                      v-if="
                        index >= (page - 1) * pageLimit &&
                        index < page * pageLimit
                      "
                    >
                      <!-- <td>{{formatDate(val.Canceled)}}</td> -->
                      <td>{{ formatDate(val.Canceled || val.sortDate) }}</td>
                      <td>{{ val.OrderId }}</td>
                      <td>
                        {{ val.Symbol }}
                        <!-- <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(val.Symbol.split('-')[0])">{{ $env_var.restricted_currencies[val.Symbol.split('-')[0]].currency_name }}</span>
                        <span v-else>{{ val.Symbol.split('-')[0] || "-" }}</span>
                        -
                        <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(val.Symbol.split('-')[1])">{{ $env_var.restricted_currencies[val.Symbol.split('-')[1]].currency_name }}</span>
                        <span v-else>{{ val.Symbol.split('-')[1] || "-" }}</span> -->
                      </td>
                      <td
                        :class="
                          val.OrderSide == 0
                            ? 'red'
                            : val.OrderSide == 1
                            ? 'green'
                            : ''
                        "
                      >
                        {{
                          val.OrderSide == 0
                            ? "SELL"
                            : val.OrderSide == 1
                            ? "BUY"
                            : "-"
                        }}
                      </td>
                      <td>{{ orderType[val.OrderType] }}</td>
                      <!-- <td>
                        <span class="status yellowBG">{{ val.OrderId }}</span>
                      </td> -->
                      <td>
                        {{ val.Symbol }}
                       <!--  <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(val.Symbol.split('-')[0])">{{ $env_var.restricted_currencies[val.Symbol.split('-')[0]].currency_name }}</span>
                        <span v-else>{{ val.Symbol.split('-')[0] || "-" }}</span>
                        -
                        <span v-if="val.Symbol != undefined && val.Symbol != null && val.Symbol != '' && $env_var.restricted_currencies.hasOwnProperty(val.Symbol.split('-')[1])">{{ $env_var.restricted_currencies[val.Symbol.split('-')[1]].currency_name }}</span>
                        <span v-else>{{ val.Symbol.split('-')[1] || "-" }}</span> -->
                      </td>
                      <!-- <td>{{ val.Price }}</td> -->
                      <td>{{ val.Quantity }}</td>
                      <!-- <td>$173.16</td>
                      <td>$41,148.50</td>
                      <td>$175.82</td> -->
                      <td>{{ val.Reason }}</td>
                      <td>
                        <span class="alert alert-primary">Cancelled</span>
                      </td>
                      <td>{{val.Commentary || '-'}}</td>
                    </tr>
                  </tbody>
                  <table-loader
                    :pageloader_value="pageLoader"
                    :type="'table'"
                    :colspan="'10'"
                    :listLength="orderData('3').length"
                    v-else
                  ></table-loader>
                </table>
              </div>
            </div>
            <pagination
              :totalRecords="orderData('3').length"
              :limit="pageLimit"
              :pageNo="page"
              v-if="orderData('3').length > 0 && !pageLoader && type == '3'"
            ></pagination>
          </div>

          <!----deposit---->
          <div  class="border position-relative border-radius-15"  v-show="type == '4'">
            <div class="row justify-content-center">
              <div class="col-12">
                <div class="d-flex align-items-center justify-content-between border-bottom p-3">
                  <div class="d-flex align-items-center">
                  <div class="form-group position-relative includeIco searchTable mb-0">
                    <input
                      type="text"
                      placeholder="Search by Orders Number"
                      name="legal_name"
                      class="form-control small"
                      v-model="searchOrderNumber"
                    />
                    <span class="searchIco"
                      ><feather type="search"></feather>
                    </span>
                  </div>
                  </div>
                  <div class="filterCustom d-flex justify-content-end transactionId" >
                    
                    <!-- <div class="form-group mr-2 mb-0">
                      
                      <select name="Date" class="form-control" v-model="dateType"  @change="changeFilterForDownload()">
                        <option value="">Select Days</option>
                        <option value="7 Days">Last 7 Days</option>
                        <option value="15 Days">Last 15 Days</option>
                        <option value="30 Days">Last 30 Days</option>
                        <option value="3 Months">Last 3 Months</option>
                        <option value="6 Months">Last 6 Months</option>
                      </select>
                    </div> -->
                    <a href="javascript:void(0)"  @click="showDownloadHistoryFlag = true" class="borderBtn ml-2 mb-0" >Download History</a>
                    
                    <!-- <a
                      href="javascript:void(0)"
                      v-if="filteredOrders.length"
                      @click="() => downloadTransactions()"
                      class="borderBtn mr-3"
                      >Download Transactions</a
                    > -->
                    
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="tableStructure tableheightScroll"> -->
              <div class="marketData table-responsive">
                <table class="table table-striped table-bordered table-responsive" width="100%">
                  <thead class="thead-white">
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Asset</th>
                      <th scope="col">Deposit Address</th>
                      <th scope="col">TX ID</th>
                      <th scope="col">Hash</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody v-if="filteredOrders.length && !pageLoader">
                    <tr v-for="(val, index) in filteredOrders">
                      <td>{{ formatDate(val.created) }}</td>
                      <td>
                        <!-- {{ val.currency }} -->
                        <span v-if="val.currency != undefined && val.currency != null && val.currency != '' && $env_var.restricted_currencies.hasOwnProperty(val.currency)">{{ $env_var.restricted_currencies[val.currency].currency_name }}</span>
                        <span v-else>{{ val.currency || "-" }}</span>
                       
                      </td>
                      <td>{{ val.dep_address }}</td>
                      <td>{{ val.transaction_id }}</td>
                      <td>{{ val.hash }}</td>
                      <td>
                        <p>
                          {{
                            parseFloat(
                              parseFloat(
                                val.deposit_fee &&
                                  val.deposit_fee != "" &&
                                  val.deposit_fee != null
                                  ? val.deposit_fees
                                  : 0
                              ) + parseFloat(val.amount)
                            ).toFixed(10)
                          }}
                        </p>
                        <p>
                          Minus Fee :
                          {{
                            val.deposit_fee &&
                            val.deposit_fees != "" &&
                            val.deposit_fees != null
                              ? parseFloat(val.deposit_fees).toFixed(10)
                              : 0
                          }}
                        </p>
                        <p>
                          Net :
                          {{
                            val.amount != "" && val.amount != null
                              ? parseFloat(val.amount).toFixed(10)
                              : 0
                          }}
                        </p>
                      </td>
                      <td>
                        <span
                          class="alert"
                          :class="getStatusClass(val.payment_status)"
                          >{{ getStatus(val.payment_status) }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                  <table-loader
                    :pageloader_value="pageLoader"
                    :type="'table'"
                    :colspan="'8'"
                    :listLength="depsitList.totalRecords"
                    v-else
                  ></table-loader>
                </table>
              </div>
            <!-- </div> -->
            <pagination
              :totalRecords="depsitList.totalRecords"
              :limit="pageLimit"
              :pageNo="page"
              v-if="
                'totalRecords' in depsitList &&
                depsitList.totalRecords > 0 &&
                type == '4'
              "
            ></pagination>
          </div>

          <!----withdrawals--->
          <div class="inFilter-area border position-relative border-radius-15" v-show="type == '5'">
            <div class="row justify-content-center">
              <div class="col-12">
                <div class="d-flex align-items-center justify-content-between border-bottom p-3">
                  <div class="d-flex align-items-center">
                  <div class="form-group position-relative includeIco searchTable mb-0">
                    <input
                      type="text"
                      placeholder="Search by Orders Number"
                      name="legal_name"
                      class="form-control small"
                      v-model="searchOrderNumber"
                    />
                    <span class="searchIco"
                      ><feather type="search"></feather>
                    </span>
                  </div>
                  </div>
                  <div class="filterCustom d-flex justify-content-end transactionId" >
                    
                    <!-- <div class="form-group mr-2 mb-0">
                      <select name="Date" class="form-control" v-model="dateType"  @change="changeFilterForDownload()">
                        <option value="">Select Days</option>
                        <option value="7 Days">Last 7 Days</option>
                        <option value="15 Days">Last 15 Days</option>
                        <option value="30 Days">Last 30 Days</option>
                        <option value="3 Months">Last 3 Months</option>
                        <option value="6 Months">Last 6 Months</option>
                      </select>
                    </div> -->
                    <a  href="javascript:void(0)"  @click="showDownloadHistoryFlag = true" class="borderBtn ml-2 mb-0" >Download History</a>
                    
                    <!-- <a
                      href="javascript:void(0)"
                      v-if="filteredOrders.length"
                      @click="() => downloadTransactions()"
                      class="borderBtn mr-3"
                      >Download Transactions</a
                    > -->
                    
                  </div>
                </div>
              </div>
            </div>
            <div class="tableStructure tableheightScroll">
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-responsive" width="100%">
                  <thead class="thead-white">
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Asset</th>
                      <th scope="col">Transaction Hash</th>
                      <th scope="col">Address</th>
                      <th scope="col">Type</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody v-if="filteredOrders.length && !pageLoader">
                    <tr v-for="(val, index) in filteredOrders">
                      <td width="220">{{ formatDate(val.created) }}</td>
                      <td>
                        <!-- {{ val.currency }} -->
                        <span v-if="val.currency != undefined && val.currency != null && val.currency != '' && $env_var.restricted_currencies.hasOwnProperty(val.currency)">{{ $env_var.restricted_currencies[val.currency].currency_name }}</span>
                        <span v-else>{{ val.currency || "-" }}</span>
                      </td>
                      <td>
                        <!-- <span v-if="val.ticket != undefined && val.ticket != null && val.ticket != ''">{{ val.ticket }}</span>
                        <span v-else>-</span> -->
                        
                        <div class="trnsIDcopy">
                          <a
                            class="underline"
                            :href="
                              redirecttoPage(
                                val.txn_web,
                                val.crypto_tx_id,
                                val.currency
                              )
                            "
                            target="_blank"
                            v-if="val.crypto_tx_id != ''"
                          >
                            {{ val.crypto_tx_id }}
                          </a>
                          <p v-else>-</p>
                        </div>
                      </td>
                      <td>
                        <span v-if="val.address != undefined && val.address != null && val.address != ''">{{val.address}}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="val.withdrawal_method != undefined && val.withdrawal_method != null && val.withdrawal_method != ''">{{ $env_var.withdrawal_type[parseInt(val.withdrawal_method)] }}</span>
                        <span v-else>-</span>
                      </td>
                      <td width="150">{{ val.amount }} <span v-if="val.currency != undefined && val.currency != null && val.currency != '' && $env_var.restricted_currencies.hasOwnProperty(val.currency)">{{ $env_var.restricted_currencies[val.currency].currency_name }}</span>
                        <span v-else>{{ val.currency || "-" }}</span></td>
                      <td width="100">
                        <span
                          class="alert"
                          :class="getStatusClass(val.withdrawal_status)"
                          >{{ getStatus(val.withdrawal_status) }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                  <table-loader
                    :pageloader_value="pageLoader"
                    :type="'table'"
                    :colspan="'8'"
                    :listLength="withdrawalList.totalRecords"
                    v-else
                  ></table-loader>
                </table>
              </div>
            </div>
            <pagination
              :totalRecords="withdrawalList.totalRecords"
              :limit="pageLimit"
              :pageNo="page"
              v-if="
                'totalRecords' in withdrawalList &&
                withdrawalList.totalRecords > 0 &&
                type == '5'
              "
            ></pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- Download Transactions History -->
    <div
      class="modal fade download"
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered max-800" role="document">
        <div class="modal-content">
          <div
            class="p-4 d-flex align-items-center justify-content-between border-bottom pb-3"
          >
            <h4 class="mb-0 medium">Download Transactions History</h4>
            <button
              type="button"
              class="close text-right pr-2"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-4">
            <p class="themecolor mb-md-5">
              CSV file lets you import your transactions into a spreadsheet,
              while the PDF format acts as a printable statement for your
              records. Both formats contain the same information.
            </p>
            <div class="row mx-0">
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <select class="form-control">
                    <option>All Time</option>
                    <option>All Time</option>
                  </select>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <select class="form-control">
                    <option>All Assets</option>
                    <option>All Assets</option>
                  </select>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <select class="form-control">
                    <option>All Transactions</option>
                    <option>All Transactions</option>
                  </select>
                </div>
              </div>
            </div>
            <ul class="border report mt-4">
              <li
                class="d-flex align-items-center justify-content-between border-bottom"
              >
                <span class="d-flex align-items-center">
                  <feather type="file-text"></feather>
                  <p class="ml-3 mb-0 themecolor">CSV Report</p>
                </span>
                <a
                  href="javascript:void(0)"
                  class="cap_btn small secondary border-btn"
                  >Generate Report</a
                >
              </li>
              <li class="d-flex align-items-center justify-content-between">
                <span class="d-flex align-items-center">
                  <feather type="file-text"></feather>
                  <p class="ml-3 mb-0 themecolor">CSV Report</p>
                </span>
                <a
                  href="javascript:void(0)"
                  class="cap_btn small secondary border-btn"
                  >Generate Report</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    

   
    <div class="modal fade review " style="display: block" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true"  :class="(showDownloadHistoryFlag)? 'show' : ''" v-show="showDownloadHistoryFlag">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content" >
          <div class="p-4 border-bottom modal-header bg-none">
            <h4 class="mb-0">Download History</h4>
            <loader v-if="pageLoader" />
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showDownloadHistoryFlag = false; dateType = ''">
                <span aria-hidden="true" >&times;</span>
            </button>
          </div>
          <div class="modal-body" >
            <div class="form-group mb-3">
              <select name="Date" class="form-control" v-model="dateType">
                <option value="">Select Days</option>
                <option value="7 Days">Last 7 Days</option>
                <option value="15 Days">Last 15 Days</option>
                <option value="30 Days">Last 30 Days</option>
                <option value="3 Months">Last 3 Months</option>
                <option value="6 Months">Last 6 Months</option>
              </select>
            </div>
            <div class="form-group mb-0 d-flex align-items-center">
              <a href="javascript:void(0)" class="cap_btn large_btn" @click="changeFilterForDownload()">Submit</a>
              <a href="javascript:void(0)" class="cap_btn large_btn border-btn ml-3" @click="showDownloadHistoryFlag = false; dateType = ''">Cancel</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import orderList from "./order/list";
import tradingMixins from "@/plugins/trading";
import depositWithdrawalMixins from "@/plugins/depositWithdrawal";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import math from "../../../../static/website/js/math.js";
import moment from "moment";
export default {
  name: "transaction-history",
  mixins: [tradingMixins, depositWithdrawalMixins],
  data() {
    return {
      dateType: "",
      downloadData : {},
      showDownloadHistoryFlag : false,


      pageLoader: false,
      currencies: false,
      notification_msg: "",
      notification_type: "",
      type: "2",
      page: "1",
      searchOrderNumber: "",
      pageLimit: "10",
      search: "",
      orderType: {
        M: "Instant Exchange",
        L: "Limit",
        S: "Stop",
        SL: "Stop Limit",
      },
      orderSide: {
        0: "Sell",
        1: "Buy",
      },
      deleteOrderVal: {},
      dateType: "",
      fromDate: "",
      toDate: "",
      basicAdv: false,
      submitted: false,
      copy_msg: "-1",
      statusTypeList: {
        CREATED: { text: "Pending", class: "yellow" },
        FILLED: { text: "Approved", class: "green" },
        CANCELED: { text: "Rejected", class: "red" },
      },
      notCryptoCurrency: ["EURO", "USD", "AUD", "GBP", "JPY"],
    };
  },
  components: {
    orderList,
  },
  computed: {
    dayTime() {
      let hour = parseInt(moment().format("HH"));
      if (hour >= 17) return "evening";
      if (hour >= 12) return "afternoon";
      return "morning";
    },
    filteredOrders() {
      let regexp = new RegExp(this.searchOrderNumber, "i");
      if (this.type == "1") {
        if (this.searchOrderNumber != "") {
          return this.orderData("1").filter((i) => {
            return `${i.OrderId}`.match(regexp);
          });
        } else {
          return this.orderData("1");
        }
      } else if (this.type == "2") {
        if (this.searchOrderNumber != "") {
          return this.orderData("2").filter((i) => {
            return `${i.OrderId}`.match(regexp);
          });
        } else {
          return this.orderData("2");
        }
      } else if (this.type == "3") {
        if (this.searchOrderNumber != "") {
          return this.orderData("3").filter((i) => {
            return `${i.OrderId}`.match(regexp);
          });
        } else {
          return this.orderData("3");
        }
      } else if (this.type == "4") {
        if (this.searchOrderNumber != "") {
          return this.depsitList.records
            ? this.depsitList.records.filter((i) => {
                return (i.dep_address.includes(this.searchOrderNumber) || i.transaction_id.includes(this.searchOrderNumber) || i.hash.includes(this.searchOrderNumber)) ;
              })
            : [];
        } else {
          return this.depsitList.records;
        }
      } else if (this.type == "5") {
        if (this.searchOrderNumber != "") {
          console.log('inn==',this.withdrawalList.records)
          return this.withdrawalList.records
            ? this.withdrawalList.records.filter((i) => {
                return ((i.address != null && i.address.includes(this.searchOrderNumber)) || (i.currency != null && i.currency.includes(this.searchOrderNumber)) || (i.txn_web != null && i.txn_web.includes(this.searchOrderNumber))) ;          
              })
            : [];
        } else {
          return this.withdrawalList.records;
        }
      }
    },
  },
  watch: {
    tradingAccount(value) {
      if (!parseInt(this.accountSelected)) {
        this.orderlisting(value, 1);
      }
    },
    socialAccount(value) {
      if (parseInt(this.accountSelected) == 1) {
        this.orderlisting(value, 1);
      }
    },
    type(value) {
      this.searchOrderNumber = "";
    },
  },
  methods: {
    changeFilterForDownload() {
      if(this.dateType != ''){
        if (this.type == "4") {
          this.depositListing();
        } else if (this.type == "5") {
          this.withdrawalListing();
        }
      }else{
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Please select field',
          duration: 1000
        });
      }
    },
    changeFilter() {
      if (parseInt(this.accountSelected) == 1) {
        this.orderlisting(this.socialAccount, 1);
      } else {
        this.orderlisting(this.tradingAccount, 1);
      }
    },
    floatingValue(value, currency) {
      try {
        if (this.notCryptoCurrency.includes(currency)) {
          return parseFloat(value).toFixed(2);
        } else {
          return this.formatfloat(parseFloat(parseFloat(value).toFixed(8)));
        }
      } catch (e) {
        return 0;
      }
    },
    getStatusClass(val) {
      try {
        return this.depositStatus[val].class || "";
      } catch (e) {
        return "";
      }
    },
    getStatus(val) {
      try {
        return this.depositStatus[val].name || "-";
      } catch (e) {
        return "-";
      }
    },
    orderData(type) {
      if (type == "1") {
        return this.orderList.records.filter((val) => val.Status == "CREATED");
      } else if (type == "2") {
        return this.orderList.records.filter((val) => val.Status == "FILLED");
      } else if (type == "3") {
        return this.orderList.records.filter((val) => val.Status == "CANCELED");
      }
    },
    redirecttoPage(type, id, currency) {
      if (type == "etherscan") {
        return this.$env_var.transactionWebsiteLink[type] + id;
      }else if (type == "tronscan") {
        return this.$env_var.transactionWebsiteLink[type] + id;
      } else if (type == "tokenview") {
        return this.$env_var.transactionWebsiteLink[type] + id;
      } else if (type == "blockchair") {
        return (
          this.$env_var.transactionWebsiteLink[type] +
          this.getcurrency(type, currency).toLowerCase() +
          "/transaction/" +
          id
        );
      } else if (type == "blockchain") {
        return (
          this.$env_var.transactionWebsiteLink[type] +
          currency.toLowerCase() +
          "/tx/" +
          id
        );
      } else if (type == "blockcypher") {
        return (
          this.$env_var.transactionWebsiteLink[type] +
          currency.toLowerCase() +
          "/tx/" +
          id +
          "/"
        );
      } else if (type == "coinmarketcap") {
        return (
          this.$env_var.transactionWebsiteLink[type] +
          this.getcurrency(type, currency).toLowerCase() +
          "/" +
          id
        );
      }
    },
    getcurrency(gettype, getcurrency) {
      var cur = Object.values(this.$env_var.walletCurrencyList).filter(
        (val) => {
          return val.symbol == getcurrency;
        }
      );
      if (gettype == "coinmarketcap") {
        var s = this.$env_var.walletCurrencyName[
          this.$env_var.Symbols[cur[0].symbol.toUpperCase()]
        ].replace(/ +/g, "-");
        return s;
      } else {
        var s = this.$env_var.walletCurrencyName[
          this.$env_var.Symbols[cur[0].symbol.toUpperCase()]
        ].replace(/ +/g, "-");
        return s;
      }
    },
    onCopy(e) {
      this.copy_msg = e.text;
      var _that = this;
      setTimeout(function () {
        _that.copy_msg = "-1";
      }, 2000);
    },
    onError(e) {
      var _that = this;
      try {
        _that.notification_msg = "Id not Copied";
        _that.notification_type = "error";
        setTimeout(function () {
          _that.notification_msg = "";
          _that.notification_type = "";
        }, 5000);
      } catch (e) {}
    },
    depositListing() {
      let jsonData = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search
        },
        localParams: { parameter: this },
      };
      if(this.dateType != ''){
        if (this.dateType == "7 Days") {
          jsonData.globalParams.filter.from = moment().subtract(7, "days").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "15 Days") {
          jsonData.globalParams.filter.from = moment().subtract(15, "days").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "30 Days") {
          jsonData.globalParams.filter.from = moment().subtract(30, "days").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "3 Months") {
          jsonData.globalParams.filter.from = moment().subtract(3, "months").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "6 Months") {
          jsonData.globalParams.filter.from = moment().subtract(6, "months").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        }
        jsonData.localParams.pageFlag = 'download'
      }else{
        jsonData.globalParams.page = this.page;
        jsonData.globalParams.perPage = parseInt(this.pageLimit);
      }
      this._runGetDepsitList(jsonData);
    },
    withdrawalListing() {
      let jsonData = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search
        },
        localParams: { parameter: this },
      };

      if(this.dateType != ''){
        if (this.dateType == "7 Days") {
          jsonData.globalParams.filter.from = moment().subtract(7, "days").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "15 Days") {
          jsonData.globalParams.filter.from = moment().subtract(15, "days").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "30 Days") {
          jsonData.globalParams.filter.from = moment().subtract(30, "days").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "3 Months") {
          jsonData.globalParams.filter.from = moment().subtract(3, "months").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "6 Months") {
          jsonData.globalParams.filter.from = moment().subtract(6, "months").format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        }
        jsonData.localParams.pageFlag = 'download'
      }else{
        jsonData.globalParams.page = this.page;
        jsonData.globalParams.perPage = parseInt(this.pageLimit);
      }
      this._runGetWithdrawalList(jsonData);
      // if(this.pageLoader){return;}
      // this._runGetWithdrawalList({
      //   globalParams: {
      //     filter: {},
      //     sort: [],
      //     search: this.search,
      //     page: this.page,
      //     perPage: parseInt(this.pageLimit),
      //   },
      //   localParams: { parameter: this },
      // });
    },
    listing() {
      if (this.type == "4") {
        this.depositListing();
      } else if (this.type == "5") {
        this.withdrawalListing();
      }
    },
    orderlisting(value, isCalling) {
      if (
        value.length > 0 &&
        (this.orderList.records.length == 0 || isCalling)
      ) {
        let jsonData = {
          globalParams: {
            filter: {},
            account_id: value[0].account_id,
            demo_live: value[0].demo_live,
          },
          localParams: { parameter: this },
        };
        if (this.dateType == "7 Days") {
          jsonData.globalParams.filter.from = moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "15 Days") {
          jsonData.globalParams.filter.from = moment()
            .subtract(15, "days")
            .format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "30 Days") {
          jsonData.globalParams.filter.from = moment()
            .subtract(30, "days")
            .format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "3 Months") {
          jsonData.globalParams.filter.from = moment()
            .subtract(3, "months")
            .format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        } else if (this.dateType == "6 Months") {
          jsonData.globalParams.filter.from = moment()
            .subtract(6, "months")
            .format("YYYY-MM-DD");
          jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
        }
        this._runGetOrderList(jsonData);
      }
    },
    formatfloat(num) {
      // return num
      num = parseFloat(num);
      try {
        return math.format(num, { notation: "fixed" }) || "";
      } catch (e) {
        try {
          return num.toFixed(8);
        } catch (e) {
          return "";
        }
      }
    },
    open(val) {
      $(".mid_scroll_content").addClass("openModal");
      this.deleteOrderVal = val;
    },
    close() {
      $(".mid_scroll_content").removeClass("openModal");
      this.deleteOrderVal = {};
    },
    cancelOrder() {
      let tradeAcc = [];
      if (parseInt(this.accountSelected) == 1) {
        tradeAcc = this.socialAccount;
      } else {
        tradeAcc = this.tradingAccount;
      }
      if (tradeAcc[0]) {
        let orderJson = {
          account_id: tradeAcc[0].account_id,
          order_id: this.deleteOrderVal.OrderId,
          localParams: this,
        };
        this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
          "S_PF_PF"
        ].cancelOrder(orderJson);
      }
    },
    successWs() {
      this.close();
    },
    failedWs() {
      console.log("failed");
    },
    findDate() {},
    downloadTransactions() {
      let headerCols = [],
        data = [],
        filename = "", download_data_send = [];

      if(this.type == "1"){
        if(this.orderData(this.type).length > 0){
          for(let i=0 ; i<= this.orderData(this.type).length-1 ; i++){
            delete this.orderData(this.type)[i].AccountID ;

            if(i == this.orderData(this.type).length-1){
              download_data_send = this.orderData(this.type)
            }
          }
        }
      }else if(this.type == "2"){
        if(this.orderData(this.type).length > 0){
          for(let i=0 ; i<= this.orderData(this.type).length-1 ; i++){
            delete this.orderData(this.type)[i].AccountID ;
            delete this.orderData(this.type)[i].StopPrice ;
            delete this.orderData(this.type)[i].sortDate ;
            if(i == this.orderData(this.type).length-1){
              download_data_send = this.orderData(this.type)
            }
          }
        }
      }else if(this.type == "3"){
        if(this.orderData(this.type).length > 0){
          for(let i=0 ; i<= this.orderData(this.type).length-1 ; i++){
            delete this.orderData(this.type)[i].Reason ;
            delete this.orderData(this.type)[i].Price ;
            delete this.orderData(this.type)[i].sortDate ;
            if(i == this.orderData(this.type).length-1){
              download_data_send = this.orderData(this.type)
            }
          }
        }
      }else if(this.type == "4" || this.type == "5" ){
        download_data_send = this.downloadData.records
      }

      // console.log(download_data_send.length)
      if(download_data_send.length > 0){
        if (this.type == "1") {
          filename = "open_orders";
          headerCols = Object.keys(this.orderData(this.type)[0]);
          data = this.orderData(this.type);
        } else if (this.type == "2") {
          filename = "completed_orders";
          headerCols = Object.keys(this.orderData(this.type)[0]);
          data = this.orderData(this.type);
        } else if (this.type == "3") {
          filename = "rejected_orders";
          headerCols = Object.keys(this.orderData(this.type)[0]);
          data = this.orderData(this.type);
        } else if (this.type == "4") {
          filename = "deposits";
          headerCols = Object.keys(this.downloadData.records[0]);
          data = this.downloadData.records;
        } else if (this.type == "5") {
          filename = "withdrawals";
          headerCols = Object.keys(this.downloadData.records[0]);
          data = this.downloadData.records;
        }
        this.csvExport(data, headerCols, filename);
      }else{
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'No data available',
          duration: 1000
        });
      }
    },
    csvExport(data, headers, filename) {
      let csvData = headers.join(", ").replace(/_/g, " ").toUpperCase();
      csvData += "\n";
      data.map((row) => {
        headers.map((i, index) => {
          if (index < headers.length - 1) {
            csvData += `${row[i]}, `;
          } else {
            csvData += `${row[i]}\n`;
          }
        });
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvData);
      hiddenElement.target = "_blank";
      hiddenElement.download = filename;
      hiddenElement.click();
    },
  },
  updated() {
    $(
      ".innerScrollbar, .tableCustomScroll-filter, .tableheightScroll"
    ).overlayScrollbars({});
  },
  created() {
    this.pageName("TRANSACTION HISTORY");
    if (parseInt(this.accountSelected) == 1) {
      this.orderlisting(this.socialAccount, 0);
    } else {
      this.orderlisting(this.tradingAccount, 0);
    }
    this.depositListing();
    this.withdrawalListing();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/transaction-history/transaction-history.vue